import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { VehicleReportModel } from 'src/app/models/vehicle-report.model';
import { Constants } from 'src/app/constants/constants';
import { VehicleService } from 'src/app/services/vehicle/vehicle.service';


@Component({
  selector: 'modal-vehicle-report',
  templateUrl: './modal-vehicle-report.component.html',
  styleUrls: ['./modal-vehicle-report.component.scss'],
})
export class ModalVehicleReportComponent implements OnInit {

  uid: number;
  reg: string;
  readOnly = false;

  newCert = new VehicleReportModel();
  existingReport = null;

  constructor(public appearanceService: AppearanceService, public vehicleService: VehicleService,
   public userService: UserService, public modalController: ModalController) {

  }


  ngOnInit() 
  {

  }


  ionViewWillEnter()
  {
    this.newCert.vehicleUid = this.uid;
    this.newCert.other = "";
    
    if(this.existingReport)
    {
      this.newCert = JSON.parse(JSON.stringify(this.existingReport));
    }
  }


  ionViewWillLeave()
  {

  }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'CreateVehicleReportModal');
  }


  submitVehicleReport()
  {
    this.appearanceService.showLoading("Please wait...").then(() => {

      this.vehicleService.submitNewVehicleReport(this.newCert).subscribe((response: any)  => {

          this.appearanceService.dismissLoading();

          if (response.Success) 
          {
            this.appearanceService.presentToast("Report submitted", Constants.TOAST_SUCCESS);
            this.modalController.dismiss(null, null, 'CreateVehicleReportModal');
          }
          else 
          {
            this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
          }
        },
        err => 
        {
          this.appearanceService.dismissLoading();
          this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
        });
    });
  }
}
